import { ProduktDiameterfordelningDTO } from "~app/common/models/produkt/ProduktDiameterfordelningDTO";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ProduktDetailTexts } from "~app/features/forsaljning/produkt/produkt-detail/produkt-detail.texts";

export class LangdmodulModalValidation {
    static init(langd: number, diameterfordelningar: ProduktDiameterfordelningDTO[], min: number, max: number): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) =>
                    !(ObjectUtils.isNullOrUndefined(newValue) ||
                    diameterfordelningar.some(p => p.produktLangdfordelningar.some(pp => pp.langdBotten === newValue)) ||
                    newValue < min ||
                    newValue > max ||
                    !/^\d+$/.test(newValue as string)),
                message: { text: ProduktDetailTexts.fordelningsmatrisTab.validation.langdmodulModalLangd },
                model: () => langd,
                name: "langd"
            }
        ]);

        return context;
    }
}
